var React = require('react');

function TimesCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.682 10.268a.999.999 0 1 1-1.414 1.414L8 9.414l-2.267 2.268a.999.999 0 1 1-1.414-1.414L6.586 8 4.319 5.732a.999.999 0 1 1 1.414-1.414L8 6.586l2.268-2.268a.999.999 0 1 1 1.414 1.414L9.414 8l2.268 2.268zM8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1z"}));
}

TimesCircle.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = TimesCircle;

TimesCircle.default = TimesCircle;
